import {Routes} from '@angular/router';
import {InvalidSessionGuard} from '../../security/route/invalidSession';
import {LoginViewComponent} from './login';

export const LOGIN_ROUTES: Routes = [
    { path: 'login', component: LoginViewComponent, canActivate: [InvalidSessionGuard] }
];
